import React from 'react'

import { Text } from 'lib/components'
import IProduct from 'domains/products/models/IProduct'
import {
  displaySpecVersion,
  getProductFormatPropByName,
} from 'domains/products/utils/products'
import { getFirstSupportedProductFormat } from 'domains/products/utils/getFirstSupportedProductFormat'
import ProductCatalogExpandedRowCell from 'domains/products/components/ProductCatalog/ProductCatalogExpandedRowCell'

interface IProps extends IProduct {
  isSubRow: boolean
  isSingleProduct: boolean
  isOpen?: boolean
}

export default function SupplierProductCatalogSpecVersionCell(props: IProps) {
  const format = props.format || getFirstSupportedProductFormat(props)
  return (
    <ProductCatalogExpandedRowCell {...props}>
      <Text fontSize={13} color={props.isOpen ? 'white' : 'text'}>
        {displaySpecVersion(
          getProductFormatPropByName(
            format,
            'specificationVersion',
            'Unknown',
          )(props),
        )}
      </Text>
    </ProductCatalogExpandedRowCell>
  )
}
